export default class Routes {
  routes = {};
  helpers = {};

  /**
   * Add a mithril route to the application.
   *
   * @param name The name of the route.
   * @param path The path of the route.
   * @param component must extend `Page` component.
   * @param resolverClass An optional custom route resolver class.
   */
  add(name, path, component, resolverClass) {
    const route = {
      path,
      component
    };
    if (resolverClass) {
      route.resolverClass = resolverClass;
    }
    this.routes[name] = route;
    return this;
  }
  helper(name, callback) {
    this.helpers[name] = callback;
    return this;
  }
  extend(app, extension) {
    Object.assign(app.routes, this.routes);
    Object.assign(app.route, this.helpers);
  }
}
flarum.reg.add('core', 'common/extenders/Routes', Routes);